module.exports = __webpack_public_path__ + "static/media/barcode-scan.a5dd0c71.svg";